import { actionTypes } from "./constants";
const initialState = {
  myTodoList: {
    rows: [],
    count: 0,
  },
  globalTodoList: {
    rows: [],
    count: 0,
  },
  todoHistoryList: [],
  projectHistoryByTarget: [],
  productCaseHistoryByTarget: [],
  productHistoryByTarget: [],
  projectByTarge: {},
  productCaseByTarge: {},
  productByTarge: {},
  quotationReleaseByTarget: [],
  quotationReleaseHistoryByTarget: [],
  docDetailByTarget: {},
  faqDetailByTarget: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_MY_TODO_LIST:
      return {
        ...state, myTodoList: action.data, 
      };
    case actionTypes.SET_GLOBAL_TODO_LIST:
      return {
        ...state, globalTodoList: action.data, 
      };
    case actionTypes.SET_TODO_HISTORY_LIST_GET:
      return {
        ...state, todoHistoryList: action.data,
      };
    case actionTypes.SET_PROJECT_HISTORY_BY_TARGET:
      return {
        ...state, projectHistoryByTarget: action.data, 
      };
    case actionTypes.SET_PRODUCT_CASE_HISTORY_BY_TARGET:
      return {
        ...state, productCaseHistoryByTarget: action.data, 
      };
    case actionTypes.SET_PROJECT_BY_TARGET:
      return {
        ...state, projectByTarge: action.data, 
      };
    case actionTypes.SET_PRODUCT_CASE_BY_TARGET:
      return {
        ...state, productCaseByTarge: action.data, 
      };
    case actionTypes.SET_PRODUCT_BY_TARGET:
      return {
        ...state, productByTarge: action.data, 
      };
    case actionTypes.SET_PRODUCT_HISTORY_BY_TARGET:
      return {
        ...state, productHistoryByTarget: action.data, 
      };
    case actionTypes.SET_QUOTATION_RELEASE_BY_TARGET:
      return {
        ...state, quotationReleaseByTarget: action.data,
      };
    case actionTypes.SET_QUOTATION_RELEASE_HISTORY_BY_TARGET:
      return {
        ...state, quotationReleaseHistoryByTarget: action.data,
      };
    case actionTypes.SET_DOC_DETAIL_BY_TARGET:
      return {
        ...state, docDetailByTarget: action.data,
      };
    case actionTypes.SET_FAQ_DETAIL_BY_TARGET:
      return {
        ...state, faqDetailByTarget: action.data,
      };
    default:
      return state;
  }
};